import { SvgIconComponent } from '@mui/icons-material'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import BusinessIcon from '@mui/icons-material/Business'
import HandshakeIcon from '@mui/icons-material/Handshake'
import InventoryIcon from '@mui/icons-material/Inventory'

export interface ReferenceMenuConfig {
  id: string
  label: string
  icon: SvgIconComponent
}

export const referenceMenus: ReferenceMenuConfig[] = [
  { id: 'prompts', label: 'Prompts', icon: AutoAwesomeIcon },
  { id: 'products', label: 'Products', icon: InventoryIcon },
  { id: 'organizations', label: 'Organizations', icon: BusinessIcon },
  { id: 'deals', label: 'Deals', icon: HandshakeIcon },
]
